<!--div *ngIf="isLoaded()"-->
<div class="" cdkTrapFocus>
  <sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
  </sub-header>
  <!--dossierHeader [projectId]="project.identifier" [infoVisible]="false" [favouriteVisible]="false" [backVisible]="false"></dossierHeader>
  <div class="buttonsHeader">
    <button pButton type="button" label="Validar" icon="fa far fa-question-circle" class="p-button-warning" (click)="validate()"></button>
    <button pButton type="button" label="Guardar" icon="pi pi-check" (click)="updateAward(award)"></button>
  </div-->
  <!--<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1 ">-->
  <div #formContainer class="m-t-md"></div>
  <ng-template #noHelp>{{ 'CompanyAdmin.noresults' | translate }}</ng-template>
  <!--</p-scrollPanel>-->
</div>
<!--/div-->